import { scaleLinear, scaleTime, scaleBand } from 'd3';

export const useScaleMap = (code: string) => {
  switch (code) {
    case 'linear':
      return scaleLinear;
    case 'time':
      return scaleTime;
    case 'band':
      return scaleBand;
    default:
      return scaleLinear;
  }
};
